import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

type Props = object;

const Login: React.FC<Props> = () => {
  const { isAuthenticated, loginWithRedirect, error: auth0Error } = useAuth0();

  useEffect(() => {
    function checkUser() {
      // This will run on component mount and anytime the isAuthenticated changes
      if (!isAuthenticated) {
        const search = window.location.search;
        const params = new URLSearchParams(search);

        // Stop the redirect loop — if Auth0 already returned an error (e.g.
        // invalid_request because the client isn't authorised for a resource
        // server), re-triggering loginWithRedirect will produce the exact same
        // error indefinitely.  Show nothing and let the user or admin resolve
        // the Auth0 configuration instead.
        if (params.get('error') || auth0Error) return;
        const invitation = params.get('invitation');
        const organization = params.get('organization');
        const hostname = window.location.hostname;
        const subdomain = hostname.replace(/\.circuitry\.ai$/, '');  
        const appState = { returnTo: window.location.pathname + window.location.search };

        if (invitation && organization) {
          loginWithRedirect({
            authorizationParams: {
              invitation,
              organization,
            },
            appState,
          });
        } else if (subdomain.length > 0 && subdomain !== 'localhost' && subdomain !== '127.0.0.1' && subdomain !== 'dev' && subdomain !== 'app' && subdomain !== 'staging' && subdomain !== 'sandbox') {
          loginWithRedirect({
            authorizationParams: {
              organization: subdomain.split('.')[0]
            },
            appState,
          });
        }
        else {
          loginWithRedirect({appState});

        }

      }

    }

    checkUser();
  }, [isAuthenticated, loginWithRedirect]);

  return <></>;
};

export default Login;

